module.exports = __webpack_public_path__ + "media/images/ui__textArrowRight-685a6b7a03611550021b303f444c5d3f.png";